// Follow the same pattern as other endpoint files: export a function that
// accepts the RTK Query `builder` and returns an object of endpoint defs.
// This file must NOT import `baseApi` (that creates a circular import when
// `baseApi` imports the endpoints index). The hooks are generated from
// `baseApi.createApi(...)` so we only export the endpoint factory here.

export const riderEndpoints = (builder) => ({
  getAvailableRiders: builder.query({
    query: ({ productId, age, sumAssured, term, paymentMode } = {}) => ({
      url: '/rider/available',
      method: 'GET',
      params: {
        productId,
        age,
        sumAssured,
        term,
        paymentMode,
      },
    }),
    providesTags: (result) => {
      // API returns { success, message, data }
      const rows = result && Array.isArray(result.data) ? result.data : [];
      return rows.length > 0
        ? [
            ...rows.map(({ RiderId }) => ({ type: 'Rider', id: RiderId })),
            { type: 'Rider', id: 'LIST' },
          ]
        : [{ type: 'Rider', id: 'LIST' }];
    },
  }),

  calculateRiderPremium: builder.mutation({
    query: (data) => ({
      url: '/rider/riders/calculate-premium',
      method: 'POST',
      body: data,
    }),
  }),

  getAllRiders: builder.query({
    query: () => ({
      url: '/rider/all',
      method: 'GET',
    }),
    providesTags: (result) => {
      const rows = result && Array.isArray(result.data) ? result.data : [];
      return rows.length > 0
        ? [
            ...rows.map(({ RiderId }) => ({ type: 'Rider', id: RiderId })),
            { type: 'Rider', id: 'LIST' },
          ]
        : [{ type: 'Rider', id: 'LIST' }];
    },
  }),
});

